import { connect } from 'react-redux';
import Tests from './tests';
import { onSetActiveTestRun, selectTest, onStartTest } from '../../reducers/test.reducers';
import { navigate } from '../../reducers/navigator.reducers';
import { onExportContent } from '../../reducers/course.reducers';

const mapStateToProps = state => ({
  isLoading: state.tests.isLoading,
  groups: state.tests.tests,
  testRuns: state.tests.testRuns,
});

const mapDispatchToProps = dispatch => ({
  startNewTestRun: (test) => {
    dispatch(selectTest(test));
    dispatch(onStartTest({ testId: test.id }));
  },
  loadTest: test => dispatch(selectTest(test)),
  setTestRun: testRun => dispatch(onSetActiveTestRun(testRun)),
  navigate: route => dispatch(navigate({ route })),
  onExportContent: url => dispatch(onExportContent(url)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Tests);



// WEBPACK FOOTER //
// ./src/app/main/tests/tests.container.js